// @ts-nocheck
import { useSelector } from "react-redux";
import { cartProducts } from "../stores/cart/cartSlice";
import { ProductsSummaryCard } from "./ProductSummaryCard";
import React from "react";
import { useLanguageContext } from "../context/languageContext";

export const ProductsSummary = () => {
    const cart = useSelector(cartProducts);
    const { t } = useLanguageContext();

    return (
        <div className="space-y-3">
            {cart && cart?.map((product, index) => (
                <ProductsSummaryCard product={product} key={product.id || index} />
            ))}

            {/* Empty State protection if accessed via direct link */}
            {(!cart || cart.length === 0) && (
                <div className="py-8 text-center border-2 border-dashed border-slate-100 rounded-3xl">
                    <p className="text-xs uppercase font-black tracking-widest text-slate-300">{t("No items in bag")}</p>
                </div>
            )}
        </div>
    );
};